import {
  INFLUENCER_INTERESTED_SUCCESS,
  INFLUENCER_INTERESTED_FAILURE,
  COMPANY_INTERESTED_SUCCESS,
  COMPANY_INTERESTED_FAILURE,
  INFLUENCER_MATCH_SUCCESS,
  COMPANY_MATCH_SUCCESS,
  MATCH_FAILURE,
  MATCH_REJECT_SUCCESS,
  MATCH_REJECT_FAILURE,
  DEAL_PROPOSAL_FAILURE,
  DEAL_PROPOSAL_SUCCESS,
  UNMATCH_SUCCESS,
  UNMATCH_FAILURE,
  ARCHIVE_SUCCESS,
  ARCHIVE_FAILURE,
  VIEW_PROPOSAL,
  REJECT_PROPOSAL_SUCCESS,
  REJECT_PROPOSAL_FAILURE,
  REVISION_REQUEST_SUCCESS,
  REVISION_REQUEST_FAILURE,
  ACCEPT_DEAL_SUCCESS,
  ACCEPT_DEAL_FAILURE,
  OPEN_COMPLETE_DEAL_FORM,
  OPEN_REVIEW_CONTENT_VIEW,
  CLOSE_REVIEW_CONTENT_VIEW,
  CLOSE_COMPLETE_DEAL_FORM,
  SUBMIT_CONTENT_FAILURE,
  SUBMIT_CONTENT_SUCCESS,
  OPEN_DISPUTE_SUCCESS,
  OPEN_DISPUTE_FAILURE,
  CONTENT_COMPLETE_SUCCESS,
  CONTENT_COMPLETE_FAILURE,
  ACCEPT_DEAL_STARTED
} from '../constants';
import { dealStatuses } from '../../constants';
import axios from 'axios';

export const acceptMatch = match => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    firestore
      .collection('deals')
      .doc(match.deal.id)
      .get()
      .then(dealSnapshot => {
        if (!dealSnapshot) {
          return dispatch({
            type: MATCH_FAILURE,
            payload: { message: 'deal doesnt exist' }
          });
        }

        dealSnapshot.ref
          .update({
            status: dealStatuses.MATCHED
          })
          .then(() => {
            firestore.collection('dealStatuses').add({
              dealId: match.deal.id,
              newStatus: dealStatuses.MATCHED,
              oldStatus: dealSnapshot.data().status,
              updater: match.initiator,
              timestamp: firestore.FieldValue.serverTimestamp()
            });
          })
          .then(response => {
            if (match.deal.initiator === 'influencer') {
              dispatch({
                type: COMPANY_MATCH_SUCCESS,
                payload: {}
              });
            } else {
              dispatch({
                type: INFLUENCER_MATCH_SUCCESS,
                payload: {}
              });
            }
          });
      })
      .catch(err => {
        dispatch({
          type: MATCH_FAILURE,
          payload: { err }
        });
      });
  };
};

export const rejectMatch = match => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    firestore
      .collection('deals')
      .doc(match.deal.id)
      .get()
      .then(dealSnapshot => {
        if (!dealSnapshot) {
          return dispatch({
            type: MATCH_FAILURE,
            payload: { message: 'deal doesnt exist' }
          });
        }

        dealSnapshot.ref
          .update({
            status: dealStatuses.MATCH_REJECTED
          })
          .then(() => {
            firestore.collection('dealStatuses').add({
              dealId: match.deal.id,
              newStatus: dealStatuses.MATCH_REJECTED,
              oldStatus: dealSnapshot.data().status,
              updater: match.initiator,
              timestamp: firestore.FieldValue.serverTimestamp()
            });
          })
          .then(response => {
            dispatch({
              type: MATCH_REJECT_SUCCESS,
              payload: {}
            });
          });
      })
      .catch(err => {
        dispatch({
          type: MATCH_REJECT_FAILURE,
          payload: { err }
        });
      });
  };
};

export const submitContentInformation = (
  contentLink,
  videoId,
  dealId,
  currentUid
) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    firestore
      .collection('deals')
      .doc(dealId)
      .get()
      .then(dealSnapshot => {
        if (!dealSnapshot) {
          return dispatch({
            type: SUBMIT_CONTENT_FAILURE,
            payload: { message: 'deal doesnt exist' }
          });
        }

        firestore
          .collection('deals')
          .doc(dealId)
          .collection('content')
          .add({
            contentLink,
            videoId,
            timestamp: firestore.FieldValue.serverTimestamp()
          })
          .then(response => {
            dispatch({
              type: SUBMIT_CONTENT_SUCCESS,
              payload: {}
            });
          });
      });
  };
};

export const completeContent = (dealId, userId) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    firestore
      .collection('deals')
      .doc(dealId)
      .get()
      .then(dealSnapshot => {
        dealSnapshot.ref
          .update({
            status: dealStatuses.CONTENT_COMPLETE
          })
          .then(() => {
            firestore
              .collection('dealStatuses')
              .add({
                dealId,
                newStatus: dealStatuses.CONTENT_COMPLETE,
                oldStatus: dealSnapshot.data().status,
                updater: userId,
                timestamp: firestore.FieldValue.serverTimestamp()
              })
              .then(response => {
                dispatch({
                  type: CONTENT_COMPLETE_SUCCESS,
                  payload: {}
                });
              });
          })
          .catch(err => {
            dispatch({
              type: CONTENT_COMPLETE_FAILURE,
              payload: { err }
            });
          });
      });
  };
};

export const submitDealProposal = (
  dealId,
  updaterUid,
  proposalInfo,
  ownProps
) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    firestore
      .collection('deals')
      .doc(dealId)
      .get()
      .then(dealSnapshot => {
        if (!dealSnapshot) {
          return dispatch({
            type: MATCH_FAILURE,
            payload: { message: 'deal doesnt exist' }
          });
        }

        // update deal status to proposal_sent
        // update current-proposal to the proposal info
        // insert new array item into revisions with the proposal info
        const proposal = {
          ...proposalInfo,
          timestamp: firestore.FieldValue.serverTimestamp(),
          commissionDetails:
            'Company will escrow funds upon deal acceptance. Funds will be transferred to the content creator once the content has been accepted.',
          sender: updaterUid,
          payout: parseFloat(proposalInfo.payout)
        };
        dealSnapshot.ref
          .update({
            status: dealStatuses.PROPOSAL_SENT,
            currentProposal: proposal
          })
          .then(() => {
            firestore.collection('dealStatuses').add({
              dealId,
              newStatus: dealStatuses.PROPOSAL_SENT,
              oldStatus: dealSnapshot.data().status,
              updater: updaterUid,
              timestamp: firestore.FieldValue.serverTimestamp()
            });
          })
          .then(() => {
            firestore
              .collection('deals')
              .doc(dealId)
              .collection('proposals')
              .add({
                ...proposal,
                sender: updaterUid,
                timestamp: firestore.FieldValue.serverTimestamp()
              });
          })
          .then(response => {
            dispatch({
              type: DEAL_PROPOSAL_SUCCESS,
              payload: {}
            });
          });
      })
      .catch(err => {
        dispatch({
          type: DEAL_PROPOSAL_FAILURE,
          payload: { err }
        });
      });
  };
};

export const archiveDeal = (dealId, isCompany) => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();

    firestore
      .collection('deals')
      .doc(dealId)
      .get()
      .then(dealSnapshot => {
        if (!dealSnapshot || dealSnapshot.empty) {
          return dispatch({
            type: ARCHIVE_FAILURE,
            payload: { message: 'deal doesnt exist' }
          });
        }
        const updateObject = isCompany
          ? {
              companyArchived: true
            }
          : {
              influencerArchived: true
            };
        dealSnapshot.ref.update(updateObject).then(response => {
          dispatch({
            type: ARCHIVE_SUCCESS,
            payload: {}
          });
        });
      })
      .catch(err => {
        dispatch({
          type: ARCHIVE_FAILURE,
          payload: { err }
        });
      });
  };
};

export const unmatchDeal = (dealId, updaterUid) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    firestore
      .collection('deals')
      .doc(dealId)
      .get()
      .then(dealSnapshot => {
        if (!dealSnapshot) {
          return dispatch({
            type: MATCH_FAILURE,
            payload: { message: 'deal doesnt exist' }
          });
        }

        // update deal status to proposal_sent
        // update current-proposal to the proposal info
        // insert new array item into revisions with the proposal info
        dealSnapshot.ref
          .update({
            status: dealStatuses.UNMATCHED
          })
          .then(() => {
            firestore.collection('dealStatuses').add({
              dealId,
              newStatus: dealStatuses.UNMATCHED,
              oldStatus: dealSnapshot.data().status,
              updater: updaterUid,
              timestamp: firestore.FieldValue.serverTimestamp()
            });
          })
          .then(response => {
            dispatch({
              type: UNMATCH_SUCCESS,
              payload: {}
            });
          });
      })
      .catch(err => {
        dispatch({
          type: UNMATCH_FAILURE,
          payload: { err }
        });
      });
  };
};

export const rejectDeal = (dealId, updaterUid) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    firestore
      .collection('deals')
      .doc(dealId)
      .get()
      .then(dealSnapshot => {
        if (!dealSnapshot) {
          return dispatch({
            type: REJECT_PROPOSAL_FAILURE,
            payload: { message: 'deal doesnt exist' }
          });
        }

        dealSnapshot.ref
          .update({
            status: dealStatuses.PROPOSAL_REJECTED
          })
          .then(() => {
            firestore.collection('dealStatuses').add({
              dealId,
              newStatus: dealStatuses.PROPOSAL_REJECTED,
              oldStatus: dealSnapshot.data().status,
              updater: updaterUid,
              timestamp: firestore.FieldValue.serverTimestamp()
            });
          })
          .then(response => {
            dispatch({
              type: REJECT_PROPOSAL_SUCCESS,
              payload: {}
            });
          });
      })
      .catch(err => {
        dispatch({
          type: REJECT_PROPOSAL_FAILURE,
          payload: { err }
        });
      });
  };
};

export const viewProposal = deal => {
  return (dispatch, getState) => {
    dispatch({
      type: VIEW_PROPOSAL,
      payload: { deal }
    });
  };
};

export const openCompleteDealForm = deal => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();
    // get content
    firestore
      .collection('deals')
      .doc(deal.id)
      .collection('content')
      .get()
      .then(contents => {
        let content = [];
        if (contents.docs.length) {
          content = contents.docs.map(c => {
            return c.data();
          });
        }
        dispatch({
          type: OPEN_COMPLETE_DEAL_FORM,
          payload: {
            deal: {
              ...deal,
              content
            }
          }
        });
      });
  };
};

export const openReviewContentView = deal => {
  return (dispatch, getState) => {
    dispatch({
      type: OPEN_REVIEW_CONTENT_VIEW,
      payload: { deal }
    });
  };
};

export const closeReviewContentView = deal => {
  return (dispatch, getState) => {
    dispatch({
      type: CLOSE_REVIEW_CONTENT_VIEW
    });
  };
};

export const closeCompleteDealView = deal => {
  return (dispatch, getState) => {
    dispatch({
      type: CLOSE_COMPLETE_DEAL_FORM
    });
  };
};

export const requestRevision = (dealId, updaterUid) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    firestore
      .collection('deals')
      .doc(dealId)
      .get()
      .then(dealSnapshot => {
        if (!dealSnapshot) {
          return dispatch({
            type: REVISION_REQUEST_FAILURE,
            payload: { message: 'deal doesnt exist' }
          });
        }

        dealSnapshot.ref
          .update({
            status: dealStatuses.REVISION_REQUESTED
          })
          .then(() => {
            firestore.collection('dealStatuses').add({
              dealId,
              newStatus: dealStatuses.REVISION_REQUESTED,
              oldStatus: dealSnapshot.data().status,
              updater: updaterUid,
              timestamp: firestore.FieldValue.serverTimestamp()
            });
          })
          .then(response => {
            dispatch({
              type: REVISION_REQUEST_SUCCESS,
              payload: {}
            });
          });
      })
      .catch(err => {
        dispatch({
          type: REVISION_REQUEST_FAILURE,
          payload: { err }
        });
      });
  };
};

export const openDispute = (dealId, updaterId) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    firestore
      .collection('deals')
      .doc(dealId)
      .get()
      .then(dealSnapshot => {
        if (!dealSnapshot) {
          return dispatch({
            type: OPEN_DISPUTE_FAILURE,
            payload: { message: 'deal doesnt exist' }
          });
        }

        dealSnapshot.ref
          .update({
            status: dealStatuses.DISPUTE_OPENED
          })
          .then(() => {
            firestore.collection('dealStatuses').add({
              dealId,
              newStatus: dealStatuses.DISPUTE_OPENED,
              oldStatus: dealSnapshot.data().status,
              updater: updaterId,
              timestamp: firestore.FieldValue.serverTimestamp()
            });
          })
          .then(response => {
            dispatch({
              type: OPEN_DISPUTE_SUCCESS,
              payload: {}
            });
          });
      })
      .catch(err => {
        dispatch({
          type: OPEN_DISPUTE_FAILURE,
          payload: { err }
        });
      });
  };
};

export const acceptDeal = (dealId, updaterId) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    dispatch({
      type: ACCEPT_DEAL_STARTED,
      payload: {}
    });

    const firebase = getFirebase();
    const firestore = getFirestore();

    return firebase
      .auth()
      .currentUser.getIdToken(true)
      .then(idToken => {
        return axios
          .post(`${process.env.REACT_APP_FIREBASE_URL}/acceptDealTerms`, {
            idToken,
            dealId
          })
          .then(response => {
            firestore.collection('dealStatuses').add({
              dealId,
              newStatus: dealStatuses.DEAL_ACCEPTED,
              oldStatus: dealStatuses.PROPOSAL_SENT,
              updater: updaterId,
              timestamp: firestore.FieldValue.serverTimestamp()
            });
            return dispatch({
              type: ACCEPT_DEAL_SUCCESS,
              payload: {}
            });
          })
          .catch(err => {
            return dispatch({
              type: ACCEPT_DEAL_FAILURE,
              payload: { err }
            });
          });
      });
  };
};

export const get5RandomCompletedDeals = () => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();

    firestore
      .collection('deals')
      .where('status', '==', 'COMPLETED')
      .limit(5)
      .get()
      .then(dealSnapshots => {
        if (!dealSnapshots || !dealSnapshots.length) {
          const influencerIds = dealSnapshots.reduce(
            influencerIds,
            dealSnapshot => {
              const dealData = dealSnapshot.data();
              if (dealData) {
                return [...influencerIds, dealData.influencerId];
              }
            }
          );
        }
        return [];
      });
  };
};

const sendMatchRequest = (
  firestore,
  influencerId,
  companyId,
  campaignId,
  influencerRequested
) => {
  return firestore
    .collection('deals')
    .where('influencerId', '==', influencerId)
    .where('campaignId', '==', campaignId)
    .where('companyId', '==', companyId)
    .get()
    .then(dealSnapshot => {
      if (!dealSnapshot || !dealSnapshot.docs.length) {
        return firestore
          .add(
            { collection: 'deals' },
            {
              influencerId,
              companyId,
              campaignId,
              status: dealStatuses.OFFER,
              initiator: influencerRequested ? 'influencer' : 'company',
              createdAt: firestore.FieldValue.serverTimestamp()
            }
          )
          .then(deal => {
            firestore.collection('dealStatuses').add({
              dealId: deal.id,
              updater: influencerRequested ? influencerId : companyId,
              status: dealStatuses.OFFER,
              timestamp: firestore.FieldValue.serverTimestamp()
            });

            return campaignId;
          });
      } else {
        throw { message: 'already matched' };
      }
    });
};

export const influencerInterestedFromDashboard = (
  influencerId,
  companyId,
  campaignId
) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    sendMatchRequest(firestore, influencerId, companyId, campaignId, true)
      .then(campaignId => {
        dispatch({
          type: INFLUENCER_INTERESTED_SUCCESS,
          payload: { campaignId }
        });
      })
      .catch(err => {
        dispatch({
          type: INFLUENCER_INTERESTED_FAILURE,
          payload: { err }
        });
      });
  };
};

export const CompanyInterestedFromDashboard = (
  influencerId,
  companyId,
  campaignId
) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    sendMatchRequest(firestore, influencerId, companyId, campaignId, false)
      .then(campaignId => {
        dispatch({
          type: COMPANY_INTERESTED_SUCCESS,
          payload: { campaignId }
        });
      })
      .catch(err => {
        dispatch({
          type: COMPANY_INTERESTED_FAILURE,
          payload: { err }
        });
      });
  };
};

export const createNewProposal = (
  influencerId,
  companyId,
  prosposalInfo,
  campaignId,
  isCompany,
  updaterId
) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    const newProposal = {
      ...prosposalInfo,
      timestamp: firestore.FieldValue.serverTimestamp(),
      commissionDetails:
        'Company will escrow funds upon deal acceptance. Funds will be transferred to the content creator once the content has been accepted.',
      sender: updaterId,
      payout: parseFloat(prosposalInfo.payout)
    };
    const newDealWithProposal = {
      influencerId,
      companyId,
      campaignId,
      initiator: isCompany ? 'company' : 'influencer',
      status: dealStatuses.PROPOSAL_SENT,
      createdAt: firestore.FieldValue.serverTimestamp(),
      currentProposal: newProposal
    };

    return firestore
      .collection('deals')
      .add({
        ...newDealWithProposal
      })
      .then(dealDoc => {
        const dealId = dealDoc.id;
        return addDealStatus(
          {
            dealId: dealId,
            newStatus: dealStatuses.PROPOSAL_SENT,
            updater: isCompany ? companyId : influencerId,
            timestamp: firestore.FieldValue.serverTimestamp()
          },
          firestore
        ).then(() => {
          dispatch({
            type: isCompany
              ? COMPANY_INTERESTED_SUCCESS
              : INFLUENCER_INTERESTED_SUCCESS,
            payload: { campaignId }
          });
          return addDealProposalHistory(dealId, newProposal, firestore);
        });
      })
      .catch(err => {
        const gg = err;
      });
  };
};

const addDealProposalHistory = (dealId, newDealProposal, firestore) => {
  return firestore
    .collection('deals')
    .doc(dealId)
    .collection('proposals')
    .add({
      ...newDealProposal
    });
};

const addDealStatus = (dealStatus, firestore) => {
  return firestore.collection('dealStatuses').add({ ...dealStatus });
};

export const influencerInterested = (
  influencerId,
  companyId,
  campaignId,
  history
) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    sendMatchRequest(firestore, influencerId, companyId, campaignId, true)
      .then(campaignId => {
        dispatch({
          type: INFLUENCER_INTERESTED_SUCCESS,
          payload: { campaignId }
        });
        history.push('/discover');
      })
      .catch(err => {
        dispatch({
          type: INFLUENCER_INTERESTED_FAILURE,
          payload: { err }
        });
      });
  };
};

export const shortlistDeal = deal => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    const firebase = getFirebase();

    firebase
      .auth()
      .currentUser.getIdToken(true)
      .then(idToken => {
        axios
          .post(`${process.env.REACT_APP_FIREBASE_URL}/shortlistDeal`, {
            idToken,
            deal
          })
          .then(response => {
            const gg = response;
          })
          .catch(err => {
            const gg = err;
          });
      });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/dealActions.js